/* Motique RECODE — VideoWise shadow DOM restyle.
 * Matches VideoWise widget cards to the rd-social-card editorial design.
 * Polls window.videowiseShadowRoots (set by VideoWise's client.js) and
 * injects scoped CSS into each shadow root once it appears.
 */
(function () {
  if (window.__rdVideowiseRestyled) return;
  window.__rdVideowiseRestyled = true;

  var CSS = [
    '.vw-root__container { background: transparent !important; }',
    '.vw-cmp__in-video-card--root {',
    '  border-radius: 14px !important;',
    '  overflow: hidden !important;',
    '  background: #0a0a0a !important;',
    '  position: relative !important;',
    '  cursor: pointer !important;',
    '  transition: transform 0.3s ease, box-shadow 0.3s ease !important;',
    '}',
    '.vw-cmp__in-video-card--root:hover {',
    '  transform: translateY(-3px) !important;',
    '  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18) !important;',
    '}',
    '.vw-cmp__in-video-card--preview {',
    '  width: 100% !important;',
    '  padding-bottom: 177.77% !important;',
    '  aspect-ratio: 9 / 16 !important;',
    '  height: auto !important;',
    '}',
    '.vw-cmp__in-video-card--thumb {',
    '  position: absolute !important;',
    '  inset: 0 !important;',
    '  width: 100% !important;',
    '  height: 100% !important;',
    '}',
    '.vw-cmp__in-video-card--thumb img {',
    '  width: 100% !important;',
    '  height: 100% !important;',
    '  object-fit: cover !important;',
    '  object-position: center !important;',
    '}',
    '.rw__swiper--carousel-btn { background: rgba(10,10,10,0.85) !important; border-radius: 50% !important; }',
    '.rw__swiper--carousel-btn svg path { stroke: #fff !important; }',
    /* Mobile: force fewer, larger cards per view (better thumb UX) */
    '@media (max-width: 749px) {',
    '  .keen-slider .keen-slider__slide,',
    '  .swiper-slide {',
    '    min-width: 180px !important;',
    '  }',
    '  .vw-cmp__in-video-card--root {',
    '    min-width: 160px !important;',
    '  }',
    '  .rw__swiper--carousel-btn {',
    '    width: 28px !important;',
    '    height: 28px !important;',
    '  }',
    '}',
    '@media (max-width: 480px) {',
    '  .keen-slider .keen-slider__slide,',
    '  .swiper-slide {',
    '    min-width: 150px !important;',
    '  }',
    '  .vw-cmp__in-video-card--root {',
    '    min-width: 140px !important;',
    '  }',
    '  /* Hide carousel arrows on tiny screens (swipe is enough) */',
    '  .rw__swiper--carousel-btn { display: none !important; }',
    '}'
  ].join('\n');

  function inject(root) {
    if (!root || root._rdVwRestyled) return;
    try {
      var style = document.createElement('style');
      style.setAttribute('data-rd-restyle', '1');
      style.textContent = CSS;
      root.appendChild(style);
      root._rdVwRestyled = true;
    } catch (e) { /* no-op */ }
  }

  function tick() {
    var roots = window.videowiseShadowRoots;
    if (!roots) return false;
    var keys = Object.keys(roots);
    if (!keys.length) return false;
    keys.forEach(function (k) { inject(roots[k]); });
    return true;
  }

  // Poll for up to ~12 seconds, with backoff
  var attempts = 0;
  var max = 60;
  var iv = setInterval(function () {
    attempts++;
    if (tick() || attempts >= max) clearInterval(iv);
  }, 200);

  // Re-run on theme editor section reload
  document.addEventListener('shopify:section:load', tick);
})();
